var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero'),_c('Membership'),_c('Intro'),_c('Sample'),_c('HomeEmail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }